export default function () {
  const { $partnero } = useNuxtApp()

  const partnerKey = useCookie('partnero_partner')
  const partnerReferral = useCookie('partnero_referral')

  const data = {
    partner: {
      key: partnerKey.value
    },
    options: {
      referral_url: partnerReferral.value?.replace('/?', '?')
    }
  }

  return {
    signup ({ name, email }) {
      $partnero?.('customers', 'signup', {
        data: {
          ...data,
          key: email,
          name,
          email
        }
      })
    }
  }
}
